const booking = {
  bookingInformation: "बुकिंग जानकारी", // translated 
  cancellationPolicy: "रद्द करने की नीति", // translated 
  ourCancellationPolicy: "हमारी रद्द करने की नीति", // translated 
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "यह ऊपर दिए गए विवरण में उल्लिखित किसी भी रद्दीकरण नीति को रद्द करता है।", // translated 
  thisBookingIsNonNefundable: "यह बुकिंग अप्रतिदेय है।", // translated 
  paymentTerms: "भुगतान की शर्तें", // translated 
  paymentWillBeTakenFromYourDefault: "भुगतान आपके डिफ़ॉल्ट खाते से लिया जाएगा।", // translated 
  paymentMethod: "भुगतान विधि", // translated 
  afterTheFreeCancellationPeriodIfApplicable:
    "यदि लागू हो तो निःशुल्क रद्दीकरण अवधि के बाद", // translated 
  prebook: "पहले से बुकिंग करें", // translated 
  guests: "अतिथियों", // translated 
  payment: "भुगतान", // translated 
  byClicking: "क्लिक करके", // translated 
  youAreAgreeingToOur: "आप हमारी शर्तों से सहमत हो रहे हैं।", // translated 
  termsAndConditions: "नियम और शर्तें", // translated 
  lastBookableDate: "अंतिम बुकिंग योग्य तिथि", // translated 
  customerRemarksTextfield: "ग्राहक की टिप्पणियाँ", // translated 
  request: "अनुरोध", // translated 
};


export default booking;
